import { cn } from "@/lib/utils";

interface PaymentMethodSelectorProps {
  value: "pix" | "credit_card";
  onChange: (value: "pix" | "credit_card") => void;
}

export const PaymentMethodSelector = ({
  value,
  onChange,
}: PaymentMethodSelectorProps) => (
  <div className="grid grid-cols-2 gap-3">
    <button
      type="button"
      onClick={() => onChange("pix")}
      className={cn(
        "rounded-lg border p-3 text-sm font-medium transition-colors",
        value === "pix"
          ? "border-[#2869C1] bg-[#2869C1]/5 text-[#2869C1]"
          : "border-slate-200 text-slate-600 hover:border-slate-300",
      )}
    >
      PIX
    </button>
    <button
      type="button"
      onClick={() => onChange("credit_card")}
      className={cn(
        "rounded-lg border p-3 text-sm font-medium transition-colors",
        value === "credit_card"
          ? "border-[#2869C1] bg-[#2869C1]/5 text-[#2869C1]"
          : "border-slate-200 text-slate-600 hover:border-slate-300",
      )}
    >
      Cartão de crédito
    </button>
  </div>
);
